<template>
    <div class="app-container">
        <div class="point-container">
            <pang-title :text="$router.lang.get('商  城')" eng="Store"/>
            <pang-tab
            :tabs="tabs" v-model:current="currentTab"/>
            <shop
            :loading="loading" :title="$router.lang.get('新墨魂Online點數購買')" :subtilte="$router.lang.get('點數是什麼？')"
            :descriptions="[$router.lang.get('玩家必須先儲值點數，方可在 購買元寶 頁面購買新墨魂Online的元寶'), $router.lang.get('儲值點數時，請先確認金額後再購買')]"
            :products="pointproducts" @buy="buy" :priceFormat="priceFormat" :image="imageUrl"/>
        </div>
    </div>
</template>

<script>
import { useScreenState } from '../../store';
import request from '../../api/request'
import filters from '../../utils/filters'
import { PangTitle, PangTab } from '../../components'
import { Shop } from './components'
import message from '../../utils/message'
import pangpay from '../../utils/pangpay';

const payment_methods = [
    // 'naver',
    // 'kakao',
    // 'payco',
    // 'inicis',
    // 'mycard',
    'paypal',
    'coda',
    'razer',
]

const pathTabMapping = [
    '/shop/point',
    '/shop/prop',
    '/shop/record',
]

const imageUrl = require('../../assets/images/img_commodity01_Shopping.png')

export default {
    name: 'Point',
    components: {
        PangTitle,
        PangTab,
        Shop,
    },
    data () {
        return {
            screenState: useScreenState(),
            currentTab: 0,
            tabs: [
                this.$router.lang.get('儲值點數'),
                this.$router.lang.get('購買元寶'),
                this.$router.lang.get('購買記錄'),
            ],
            pointproducts: [],
            buyingItem: {},
            inicisForm: {},
            imageUrl: imageUrl,
            loading: true,
            payment_methods: payment_methods,
        };
    },
    computed: {
        isCollapse() {
        return this.screenState.screenWidth < 900;
        },
    },
    watch: {
        currentTab(val) {
            this.$router.replace(pathTabMapping[val])
        }
    },
    methods: {
        originPriceFormat: filters.priceFormat,
        priceFormat (value) {
            if (value)
                return 'THB฿' + filters.priceFormat(value)
            else
                return '-'
        },
        getPointProducts () {
            let params = {limit: 999}
            let _this = this
            request.get('/pointproducts' , params, _this).then(function (res) {
                if (res.status == 200) {
                    _this.pointproducts = res.data.results
                }
                else {
                    message.resMessage(res, _this)
                }
            })
        },
        buy (item) {
            let _this = this
            this.buyingItem = item
            request.get('/users/me', {}, this).then(function (res) {
                if (res.status == 200) {
                    window.localStorage.setItem('user_info', JSON.stringify(res.data))
                    _this.screenState.user = res.data
                }
                else if (res.status == 404) {
                    window.localStorage.removeItem('token')
                    window.localStorage.removeItem('user_info')
                    _this.$router.push('/account/login')
                }
                pangpay.createPangPay({
                    price: item.price,
                    subDescription: item.price?_this.$router.lang.get('Point: {point}', {point: _this.originPriceFormat(item.point)}):null,
                    currency: 'THB',
                    product: item.product,
                    buyername: _this.screenState.user.realname,
                    buyertel: _this.screenState.user.phone,
                    buyeremail: _this.screenState.user.email,
                    payment_methods: _this.payment_methods.map(function(x) {return x}),
                    showItems: item.price?[
                        {
                            label: _this.$router.lang.get('持有點數：') ,
                            value: _this.$router.lang.get('{point} 點', {point: _this.originPriceFormat(_this.screenState.user.total_point)}),
                        },
                        {
                            label: _this.$router.lang.get('儲值點數：') ,
                            value: _this.$router.lang.get('{point} 點', {point: _this.originPriceFormat(item.point)}),
                        },
                        {
                            label: _this.$router.lang.get('儲值後點數：') ,
                            value: _this.$router.lang.get('{point} 點', {point: _this.originPriceFormat(_this.screenState.user.total_point + item.point)}),
                        },
                    ]:[
                        {
                            label: '',
                            value: _this.$router.lang.get('点卡金额不能少于 THB 50'),
                        }
                    ],
                }, _this.submit, _this.approve)
            })
        },
        submit (data) {
            let _this = this
            request.post('/rechargerecords' , {
                payment_method: data.payment_method,
                channel_id: data.channel_id,
                pointproduct: this.buyingItem.id,
                is_mobile: data.isMobile
                }, this).then(function (res) {
                if (res.status == 201) {
                    _this.rechargerecord_id = res.data.id
                    res.data.returnUrl = request.baseUrl + '/rechargerecords/' + res.data.id + '/pay'
                    res.data.closeUrl = request.baseUrl + '/shop/point'
                    pangpay.submitRecord(res.data)
                }
                else {
                    message.resMessage(res, _this)
                }
            })
        },
        approve (data) {
            if (data) {
                let _this = this;
                request.post(
                    '/rechargerecords/' + _this.rechargerecord_id + '/pay',
                    data, _this).then(function (res) {
                        if (res.status == 200) {
                            _this.$router.push('/shop/record?id=' + _this.rechargerecord_id + '&isnew=true')
                        }
                        else {
                            message.resMessage(res, _this)
                        }
                    })
            }
        },
        getPaymentMethods () {
            let _this = this;
            request.get(
                '/rechargerecords/payments',
                {}, _this).then(function (res) {
                    if (res.status == 200) {
                        _this.payment_methods = res.data
                        // if (_this.$route.query.coda)
                        //     _this.payment_methods.unshift('coda')
                    }
                })
        },
    },
    mounted () {
        if (this.screenState.user) {
            this.getPointProducts()
            this.getPaymentMethods()
            let _this = this
            if (!this.screenState.pangpayTimestamp || this.screenState.pangpayTimestamp < new Date().getTime()/1000 - 3000) {
                request.get('/pangpay/sign', {}, this).then(function (res) {
                    if (res.status == 200 && res.data) {
                        res.data.payment_methods = payment_methods
                        pangpay.createPangPayIframe(res.data)
                        _this.screenState.pangpayTimestamp = res.data.timestamp
                    }
                    else
                        pangpay.createPangPayIframe({
                            payment_methods: payment_methods
                        })
                })
            }
            if (!this.screenState.pangpayIsLoaded) {
                window.addEventListener('message', function (e) {
                    if (e.data.source == 'pangpay' && e.data.message == 'pangpayReady') {
                        _this.loading = false;
                        _this.screenState.pangpayIsLoaded = true;
                    }
                })
            }
            else
                this.loading = false
        }
    },
}
</script>

<style scoped>

.point-container {
    max-width: 1042px;
    width: 90vw;
    margin: auto;
    color: #939393;
}

.des {
    font-size: 22px;
    
    font-weight: normal;
    color: #C6A86C;
    margin-top: 30px;
}

.product-detail {
    margin: 35px 0;
    line-height: 32px;
}

.detail-item {
    display: flex;
}

.detail-label {
    width: 98px;
}

</style>
